export default {
  schedule: {
    date_and_time: 'Datum en tijd*',
    number_of_guests: 'Aantal gasten*',
    location: 'Locatie:',
  },
  personal_information: {
    title: 'Titel',
    first_name: 'Voornaam',
    enter_first_name: 'Voornaam invoeren',
    last_name: 'Achternaam*',
    enter_last_name: 'Achternaam invoeren',
    email: 'E-mail',
    enter_email: 'E-mailadres invoeren',
    phone: 'Telefoon',
    annotation: 'Opmerking',
    enter_annotation: 'Opmerking invoeren',
  },
  gender: {
    without_title: 'Zonder titel',
    male: 'Dhr.',
    female: 'Mevr.',
  },
  buttons: {
    save: 'Opslaan',
  },
  error_messages: {
    invalid_email: 'Voer een geldig e-mailadres in, zonder spaties of umlauten vóór de @.',
    invalid_phone_number: 'Ongeldig telefoonnummer. Controleer uw gegevens en probeer het opnieuw.',
    failed_reservation: 'Reservering verzenden mislukt. Controleer uw gegevens en probeer het opnieuw.',
    invalid_reservation_day: 'Op deze dag accepteren wij geen reserveringen.',
    no_tables_available: 'Helaas zijn er geen tafels meer beschikbaar.',
    please_enter_guests: 'Voer het aantal gasten in.',
    please_select_time: 'Selecteer een tijd.',
    please_select_last_name: 'Voer achternaam in',
  },
  success_messages: {
    reservation_saved: 'Reservering succesvol opgeslagen',
  },
};
